"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next-nprogress-bar";
import Button from "@/components/common/shared/Button/button";
import { useAppSelector } from "@/lib/store";

const BackButton = ({
  t,
  isPDP,
  styles,
  heading,
  subHeading,
  isSearchPage,
  updatedTitle = "",
}) => {
  const router = useRouter();
  const [title, setTitle] = useState(heading);

  useEffect(() => {
    if (heading !== title) {
      setTitle(heading);
    }
  }, [heading]);

  useEffect(() => {
    if (updatedTitle) {
      setTitle(updatedTitle);
    }
  }, [updatedTitle]);
 const { plpTitle } = useAppSelector((state) => state.uiState);
  const handleGoBack = () => router.back();
  if (isSearchPage) {
    return (
      <div className="flex flex-col">
        <Button
          theme="iconOnly"
          icon="accountBack"
          iconPosition="left"
          onClick={handleGoBack}
          className="back-btn mt-4 xs:hidden"
        >
          {t("button.back")}
        </Button>
        <h1
          className={`${styles.heading32} small-heading capitalize search-heading`}
        >
          {title}
        </h1>
      </div>
    );
  }

  const HeadingTag = isPDP ? "h2" : "h1";
  return (
    <div className="flex flex-col lg:min-h-[80px] xs:min-h-[68px] min-h-[46px] sm:pt-24 xs:pt-5 pt-[10px] xs:pb-12 pb-10">
      <div className="flex lg:h-[44px] xs:h-[32px] h-[26px]">
        <Button
          theme="iconOnly"
          icon="accountBack"
          iconPosition="left"
          onClick={handleGoBack}
          className="back-btn xs:!hidden"
        ></Button>
        <HeadingTag
          className={`${styles.heading32} capitalize !mb-0 small-heading-text`}
        >
          {plpTitle?plpTitle +' '+ title:title}
        </HeadingTag>
      </div>
      <p className="text-primary-black-800 xs:text-body-text-2 text-body-text-3">
        {subHeading}
      </p>
    </div>
  );
};

export default BackButton;
